import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { PermissionsProvider } from './permissions';
import { UpdateBadge } from '@/components/UpdateBadge';
import { useUpdateBadge } from '@/hooks/useUpdateBadge';
import Login from '@/pages/Login';
import Home from '@/pages/DashboardHome';
import Timbrature from '@/pages/Timbrature';
import Turni from '@/pages/Turni';
import Mensile from '@/pages/Mensile';
import Vacanze from '@/pages/Vacanze';
import Policy from '@/pages/Policy';
import ChangePassword from '@/pages/ChangePassword';
import { Nav } from '@/components/Nav';
import { RequirePermission } from '@/components/RequirePermission';
import { useAuth } from '@/hooks/useAuth';

function Shell({ children }: { children: React.ReactNode }) {
  return (
    <div style={{ padding: 12, fontFamily: 'system-ui, sans-serif' }}>
      <img src="/logo.png" alt="Montanstahl" style={{ height: 32 }} />
      <Nav />
      <hr />
      {children}
    </div>
  );
}

function RequireAuth({ children }: { children: React.ReactNode }) {
  const { token } = useAuth();
  if (!token) return <Navigate to="/" replace />;
  return <>{children}</>;
}

export default function App() {
  const { show, applyUpdate } = useUpdateBadge();
  return (
    <BrowserRouter>
      <PermissionsProvider>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route
            path="/dashboard/*"
            element={
              <RequireAuth>
                <Shell>
                  <Routes>
                    <Route path="home" element={<Home />} />
                    <Route path="timbrature" element={<RequirePermission name="Punches"><Timbrature /></RequirePermission>} />
                    <Route path="turni" element={<RequirePermission name="Shifts"><Turni /></RequirePermission>} />
                    <Route path="conteggio-mensile" element={<RequirePermission name="Monthly bills"><Mensile /></RequirePermission>} />
                    <Route path="vacanze" element={<RequirePermission name="Leave days"><Vacanze /></RequirePermission>} />
                    <Route path="policy" element={<Policy />} />
                    <Route path="change-password" element={<ChangePassword />} />
                    <Route path="*" element={<Navigate to="home" replace />} />
                  </Routes>
                </Shell>
              </RequireAuth>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        {show && <UpdateBadge onClick={applyUpdate} />}
      </PermissionsProvider>
    </BrowserRouter>
  );
}
